import axios from 'axios';
import Auth from './auth.js';
import Router from '@/router';

import {
    AUTH_LOGIN_URL
} from '@/constants/auth.js';

import {
    API_URL
} from '@/constants/default.js';

class Api {

    /**
     * Create constructor for API class for setting axios instance and request headers.
     * 
     * @constructor
     */
    constructor() {
        // Set API URL
        this.url = API_URL;

        // Initialise axios instance
        const instance = axios.create();

        // Define request headers
        instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        
        // Attach axios instance globally
        this.axios = instance;

        // Set token if available
        const token = Auth.getToken();
        if(typeof token !== 'undefined' && token !== null) {
            this.setAuthorization(token);
        }
    }

    /**
     * Sending request method through initialised axios.
     * 
     * @param {String} method Set action type for sending request 
     * @param {String} path Path to call request
     * @param {Object} data Data values being sent through request
     * @param {Boolean} refresh Access to initialize JWT token refresh
     * 
     * @return {Promise}
     */
    request(method, path, data = {}, refreshable = true, config = {}) {
        // Define axios instance
        const r = () => this.axios[method](this.url + '/' + path, data, config);

        // Execute defined axios instance
        return r().catch(response => {
            // Check response for status code and refresh if available
            if(response.response.status === 401 && refreshable) {
                return Auth.refresh();
            }

            return Promise.reject(response);
        }).then(response => {
            // Check for access token response if refresh is available
            if(response.data.refreshed && response.data.access_token) {
                // Store token for headers and user authentication
                Auth.storeToken(this.token);
                // Set token in axios instance headers
                this.setAuthorization(response.data.access_token);
                
                // Execute request to return original request promise
                return r();
            }
    
            return Promise.resolve(response);
        }).catch(response => {
            // Failed and removal of existing localStorage token needed
            if(response.response.status === 401) {
                const token = Auth.getToken();
                if(typeof token !== 'undefined' && token !== null) {
                    Auth.removeToken();
                }
                
                // Redirect to login page
                Router.push(AUTH_LOGIN_URL);
            }

            if (response.response.status === 403 && typeof response.response.data.message != 'undefined') {
                // Need a way to access toasted.
                Auth.forbidden(response.response.data.message);
            }

            return Promise.reject(response);
        });
    }

    /**
     * Set token in Authorization header to send in axios instance requests.
     * 
     * @param {String} token 
     * 
     * @return {Void}
     */
    setAuthorization(token) {
        this.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    /**
     * Unset token from Authorization header if exists.
     * 
     * @return {Void}
     */
    unsetAuthorization() {
        delete this.axios.defaults.headers.common['Authorization'];
    }

}

export default new Api;


// WEBPACK FOOTER //
// ./src/api/index.js